<template>
  <v-row align="center" justify="center" dense>
    <v-col lg="6" sm="8" cols="12">
      <v-card class="mb-5" elevation="5">
        <v-card-title class="headline">
          {{ record.date | formatDate }}
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text>
          <v-row>
            <v-col cols="12" lg="6">
              <v-rating
                length="5"
                :value="record['happiness']"
                readonly
                empty-icon="far fa-smile"
                full-icon="far fa-smile"
                color="primary"
                background-color="grey lighten-2"
                x-large
                dense
              ></v-rating>
            </v-col>
            <v-col cols="12" lg="6">
              <v-tooltip
                bottom
                v-for="marker in getActiveMarkers(record)"
                :key="marker.name"
              >
                <template v-slot:activator="{ on }">
                  <v-icon class="ma-1" large :color="marker.color" v-on="on">
                    {{ marker.icon }}
                  </v-icon>
                </template>
                <span>{{ marker.tooltipText }}</span>
              </v-tooltip>
            </v-col>
          </v-row>

          <v-row>
            <v-col
              md="4"
              sm="6"
              cols="12"
              v-for="rating in $store.getters.moodMetrics"
              :key="rating.name"
              class="pt-0 pb-0 mt-1"
            >
              <h5>{{ rating.helpText }}</h5>
              <v-rating
                length="5"
                :value="record[rating.name]"
                readonly
                :empty-icon="rating.emptyIcon"
                :full-icon="rating.fullIcon"
                :color="rating.color"
                background-color="grey lighten-2"
                dense
              ></v-rating>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn outlined small @click="$emit('edit-record', record)"
            >Edit</v-btn
          >
          <v-btn
            color="error"
            outlined
            small
            @click="$emit('delete-record', record)"
            >Delete</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>

export default {
  name: "MoodDiaryCard",

  props: {
    record: Object
  },

  computed: {
  },

  methods: {
    getActiveMarkers: function (record) {
      return this.$store.state.moodMarkers.filter(
        marker => record[marker.name]
      );
    }
  }

}
</script>